enum VisaLetterModalSteps {
  Info = 'info',
  Recipients = 'recipients',
  Letter = 'letter',
}

export default VisaLetterModalSteps
